import React, { useEffect, useState } from "react";
import AXIOSCONFIGMETHOD from "../../../../components/apiCall/axiosConfig";
import { webServiceUrl } from "../../../../components/apiCall/webserviceurl";
import Loading from "../../../../components/common/Loading";

function About_program({ program_id }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const local = localStorage.getItem("school_code");

  const getData = async () => {
    try {
      setLoading(true);
      const resp = await AXIOSCONFIGMETHOD(
        "POST",
        webServiceUrl.about_program,
        { program_id: local },
      );
      setData(resp?.data || {});
    } catch (error) {
      console.error("Failed to fetch data", error);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {loading ? (
        <div className="py-5" style={{ height: "20vh" }}>
          <Loading />
        </div>
      ) : (
        <section className="max-w-7xl mx-auto px-6 py-12">
          {/* ✅ About Program */}
          {data?.program_description && (
            <>
              <p className="subHeading">About Program</p>
              <p>{data?.program_name}</p>
              {/* <div
                className="prose"
                dangerouslySetInnerHTML={{
                  __html: data.program_description.trim(),
                }}
              /> */}
              <div
                className="prose"
                dangerouslySetInnerHTML={{
                  __html: data.program_description.trim(),
                }}
              />
            </>
          )}

          {/* ❌ Optional sections (only if future data comes) */}
          {data?.objectives && (
            <>
              <p className="subHeading">Objectives of the Program</p>
              <div
                className="prose"
                dangerouslySetInnerHTML={{
                  __html: data.objectives.trim(),
                }}
              />
            </>
          )}

          {data?.program_methodology_text && (
            <>
              <p className="subHeading">
                Program Methodology and Implementation
              </p>
              <div
                className="prose"
                dangerouslySetInnerHTML={{
                  __html: data.program_methodology_text.trim(),
                }}
              />
            </>
          )}

          {/* ✅ Table (only render if any data exists) */}
          {(data?.imp_pt1_header ||
            data?.imp_pt2_header ||
            data?.imp_pt3_header) && (
            <div className="overflow-x-auto my-3">
              <table className="min-w-full border border-gray-300 text-sm md:text-base">
                <tbody>
                  {data?.imp_pt1_header && (
                    <tr>
                      <td className="font-semibold border p-2">
                        {data.imp_pt1_header}
                      </td>
                      <td className="border p-2">{data.imp_pt1_text}</td>
                    </tr>
                  )}

                  {data?.imp_pt2_header && (
                    <tr>
                      <td className="font-semibold border p-2">
                        {data.imp_pt2_header}
                      </td>
                      <td className="border p-2">{data.imp_pt2_text}</td>
                    </tr>
                  )}

                  {data?.imp_pt3_header && (
                    <tr>
                      <td className="font-semibold border p-2">
                        {data.imp_pt3_header}
                      </td>
                      <td className="border p-2">{data.imp_pt3_text}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </section>
      )}
    </div>
  );
}

export default About_program;

// import React, { useEffect, useState } from "react";
// import AXIOSCONFIGMETHOD from "../../../../components/apiCall/axiosConfig";
// import { webServiceUrl } from "../../../../components/apiCall/webserviceurl";
// import Loading from "../../../../components/common/Loading";

// function About_program({ program_id }) {
//   const [data, setData] = useState({});
//   const [loading, setLoading] = useState(true);

//   const getData = async () => {
//     try {
//       setLoading(true);
//       const resp = await AXIOSCONFIGMETHOD(
//         "POST",
//         webServiceUrl.about_program, {
//         program_id: program_id,
//       }
//       );
//       console.log(resp?.data?.text?.split("/n/p"));
//       setData(resp?.data);
//     } catch (error) {
//       console.error("Failed to fetch data", error);
//     } finally {
//       setTimeout(() => setLoading(false), 1000);
//     }
//   };

//   useEffect(() => {
//     getData();
//   }, []);

//   return (
//     <div>
//       {loading
//         ? <div className="py-5" style={{ height: "20vh" }}><Loading /></div>
//         : <section className="max-w-7xl mx-auto px-6 py-12">
//           <p className="subHeading">About Program</p>
//           <div
//             className="prose" // Optional TailwindCSS or styling wrapper
//             dangerouslySetInnerHTML={{
//               __html: data?.program_description?.trim() || "",
//             }}
//           />
//           <p className="subHeading">Objectives of the Program</p>
//           <div
//             className="prose" // Optional TailwindCSS or styling wrapper
//             dangerouslySetInnerHTML={{
//               __html: data?.objectives?.trim() || "",
//             }}
//           />
//           <p className="subHeading">Program Methodology and Implementation</p>
//           <div
//             className="prose" // Optional TailwindCSS or styling wrapper
//             dangerouslySetInnerHTML={{
//               __html: data?.program_methodology_text?.trim() || "",
//             }}
//           />
//           {/* <div
//       className="prose" // Optional TailwindCSS or styling wrapper
//       dangerouslySetInnerHTML={{
//         __html: data?.implementation_text?.trim() || ''
//       }}
//     /> */}
//           <div className="overflow-x-auto my-3">
//             <table
//               border="1"
//               cellPadding="8"
//               cellSpacing="0"
//               className="min-w-full border-collapse border border-gray-300 text-sm md:text-base"
//             >
//               <tbody>
//                 <tr>
//                   <td className="font-semibold border p-2">
//                     <strong>{data?.imp_pt1_header}</strong>
//                   </td>
//                   <td className="border p-2">{data?.imp_pt1_text}</td>
//                 </tr>
//                 <tr>
//                   <td className="font-semibold border p-2">
//                     <strong>{data?.imp_pt2_header}</strong>
//                   </td>
//                   <td className="border p-2">{data?.imp_pt2_text}</td>
//                 </tr>
//                 <tr>
//                   <td className="w-full md:w-1/3 font-semibold border p-2">
//                     <strong>{data?.imp_pt3_header}</strong>
//                   </td>
//                   <td className="w-full md:w-2/3 break-words border p-2">
//                     {data?.imp_pt3_text}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </section>
//       }
//     </div>
//   );
// }

// export default About_program;
